module.exports = __webpack_public_path__ + "static/media/logo_voceqpad_Prancheta_1_1x (1) (1).11dad37e.svg";